import { ConversationTrainingLabelSchema } from "@redotech/redo-model/conversation-training-label/conversation-training-label-definition";
import * as z from "zod/v4";

export const getConversationTrainingLabelsForTeam = {
  name: "getConversationTrainingLabelsForTeam" as const,
  input: z.object({ trainingSetId: z.string() }),
  output: z.array(ConversationTrainingLabelSchema),
};
